import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;
const LOCAL_STORAGE_TOKEN = '__customer-info-token__';

const axiosInstance = axios.create({
    baseURL: `${BASE_URL}`,
});

// Request: alleen Authorization header zetten (als token er is)
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(LOCAL_STORAGE_TOKEN);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response: bij sessie verlopen -> event dispatchen (AuthProvider vangt dit op)
axiosInstance.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err?.response?.status;

        // Laravel/sessie gerelateerd zie je vaak als 401 (unauth) of 419 (csrf/session expired)
        if (status === 401 || status === 419) {
            window.dispatchEvent(new Event('custinfo:session-expired'));
        }

        return Promise.reject(err);
    }
);

export default axiosInstance;
